export const updatedScrubDirectionState =
  (scrubSpeeds, requestedDirection) =>
  ({ scrubAmount, scrubDirection }) => {
    const reduceScrubbing = scrubAmount && requestedDirection !== scrubDirection
    const newScrubbing = scrubAmount + (reduceScrubbing ? -1 : 1)

    if (newScrubbing > scrubSpeeds.length) {
      return null
    }

    return {
      scrubAmount: newScrubbing,
      scrubDirection: scrubAmount === 0 ? requestedDirection : scrubDirection,
      playing: newScrubbing === 0,
    }
  }

export const updatedStateAfterScrubbing =
  (scrubInterval, scrubSpeeds) =>
  ({ scrubAmount, scrubDirection, playedSeconds, duration }) => {
    if (scrubAmount === 0) {
      return null
    }

    const { factor = 0, percent = 0 } = scrubSpeeds[scrubAmount - 1]
    const deltaSeconds =
      scrubDirection *
      Math.max(
        // The speed-up factor, i.e. seconds to jump every second, or
        factor,
        // The percentage of the total video duration to jump every second
        (duration * percent) / 100,
      )
    const newSeconds = playedSeconds + deltaSeconds * (scrubInterval / 1000)

    if (newSeconds < 0) {
      return { playedSeconds: 0, scrubAmount: 0, playing: true }
    }

    if (newSeconds > duration) {
      return { playedSeconds: duration, scrubAmount: 0, playing: true }
    }

    return { playedSeconds: newSeconds }
  }
